import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class StorageService {
  private storage = null;
  private userName$: BehaviorSubject<string | null>;

  constructor() {
    this.checkStorage();
    this.userName$ = new BehaviorSubject<string | null>(this.get('userName'));
  }

  public get(key: string): any {
    return this.storage.getItem(key);
  }

  public getObject(key: string): any {
    const res = this.storage.getItem(key);
    if (res) {
      return JSON.parse(res);
    } else {
      return null;
    }
  }

  public set(key: string, value: string): void {
    this.storage.setItem(key, value);
    if (key === 'userName') {
      this.userName$.next(value);
    }
  }

  public getUserNameObservable() {
    return this.userName$.asObservable();
  }

  public clear(): void {
    this.storage.clear();
  }

  public checkStorage() {
    if (localStorage.getItem('rememberMe') && localStorage.getItem('rememberMe') == 'true') {
      this.storage = localStorage;
    } else {
      this.storage = sessionStorage;
    }
  }
}